import moment from "moment";
import { DISCOUNT_PROGRAM_TAB } from "../../framework/tab/tabUtilsConstants";
export const newDiscountProgram = {
  category: "",
  option: "",
  min: 0,
  max: 0,
  discPerDefault: 0,
};
export const initial_state_discount_program = {
  type: DISCOUNT_PROGRAM_TAB,
  label: "Discount Program",
  actors: {
    name: "",
    start: moment().format("DD/MM/YYYY"),
    end: moment().format("DD/MM/YYYY"),
    discountProgramCode: undefined,
    branch: [],
    entity: null,
    manufacturerGroupOptions: [],
    entityOptions: [],
    allBranches: [],
  },
  discountProgramRowData: [newDiscountProgram],
  gridColumns: null,
};
export const discountProgramColDef = [
  {
    headerName: "Discount Type",
    field: "category",
    cellEditor: "cellSelectInput",
  },
  { headerName: "Option", field: "option", cellEditor: "cellTreeSelect" },
  { headerName: "Minimum Amount (₹)", field: "min" },
  { headerName: "Maximum Amount (₹)", field: "max" },
  { headerName: "Discount (%)", field: "discPerDefault" },
];

export const CategoryList = [
  // {
  //   id: "category",
  //   label: "Category",
  // },
  // {
  //   id: "manufacturer",
  //   label: "Manufacturer",
  // },
  {
    id: "manufacturer_group",
    label: "Manufacturer Group",
  },
];
